// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }
  
  .attribute {
    padding: 12px;
    border-left: 4px solid #1890ff;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    font-size: 16px;
    line-height: 1.6;
  }
  
  .attribute:hover {
    background: #e6f7ff;
    transform: translateY(-5px);
  }

  
  .files-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }
  
  .ant-card-head {
    border-bottom: 2px solid #1890ff !important; /* تغییر رنگ خط زیر عنوان به آبی */
  }
  

  
  .attribute strong {
    font-size: 17px;
  }`, "",{"version":3,"sources":["webpack://./src/views/articles/css/ArticleDetailsCard.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;;EAGA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,2CAA2C,EAAE,kCAAkC;EACjF;;;;EAIA;IACE,eAAe;EACjB","sourcesContent":[".details-card {\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n  }\n  \n  .attribute {\n    padding: 12px;\n    border-left: 4px solid #1890ff;\n    background: #fff;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: all 0.3s ease;\n    font-size: 16px;\n    line-height: 1.6;\n  }\n  \n  .attribute:hover {\n    background: #e6f7ff;\n    transform: translateY(-5px);\n  }\n\n  \n  .files-card {\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n  }\n  \n  .ant-card-head {\n    border-bottom: 2px solid #1890ff !important; /* تغییر رنگ خط زیر عنوان به آبی */\n  }\n  \n\n  \n  .attribute strong {\n    font-size: 17px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
